import cookie from 'react-cookie';

const initialState = {
  currentLocale: null,
  defaultLocale: null,
  initialNow: null,
  locales: null,
  messages: null,
};

const reducer = (state = initialState, action) => {
  if (!action) return state;

  switch (action.type) {
    case 'SET_CURRENT_LOCALE': {
      if (typeof cookie !== 'undefined') {
        cookie.save('locale', action.payload.locale, { path: '/' });
      }

      return { ...state, currentLocale: action.payload.locale };
    }

    default:
      return state;

  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/common/intl/reducer.js